import { useCurrentUser } from "../api/auth";

export const useCapabilities = () => {
  const { data: user, isLoading } = useCurrentUser();
  return { capabilities: user?.capabilities ?? [], isLoading };
};

export const useHasCapability = (code) => {
  const { capabilities } = useCapabilities();
  return capabilities.includes(code);
};
